<template>
  <div class="flex flex-col p-2 mb-3 bg-white border rounded" :style="{ maxWidth: '460px' }">
    <div v-if="sent" class="flex justify-center w-full mt-10 mb-10">
      <a-icon :style="{ fontSize: '72px', color: '#ed8936' }" type="check-circle" />
    </div>

    <h3 class="mb-2 text-center sm:text-lg" :class="sent && 'mx-auto'">
      {{
        sent
          ? 'Feedback inviato. Grazie del suggerimento'
          : 'Nessuna di queste offerte fa al caso tuo?'
      }}
    </h3>
    <div
      v-if="sent"
      @click="$emit('reset')"
      class="mx-auto mb-6 text-lg text-center cursor-pointer text-i4m-orange"
    >
      Prova una nuova ricerca
    </div>
    <p v-else class="mb-6 text-center">
      Aiutaci a migliorare. Dicci cosa ne pensi delle offerte che abbiamo trovato.
    </p>

    <div v-if="!sent">
      <div
        v-for="r in reasons"
        @click="selected = r.key"
        class="p-2 mb-1 border rounded cursor-pointer pressable"
        :key="r.key"
        :class="selected === r.key && 'border-green-400 bg-green-50'"
      >
        {{ r.label }}
      </div>
      <a-input v-model="other" class="reason-other" @focus="selected = null" placeholder="Altro" />

      <div class="flex items-center justify-end mt-8">
        <a-button size="small" @click="send" :loading="sending">
          Invia suggerimento
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api.js';

export default {
  name: 'offer-feedback',

  data() {
    return {
      sending: false,
      sent: false,
      selected: null,
      reasons: [
        { key: 'expensive', label: 'Sono troppe costose' },
        { key: 'few', label: 'Ci sono poche alternative' },
        { key: 'unclear', label: 'Le offerte sono poco chiare' }
      ],
      other: ''
    };
  },

  methods: {
    async send() {
      if (!this.selected && this.other.length <= 3) {
        return null;
      }

      if (!this.selected) {
        console.log('sending', this.other);
      }

      // user has selected one of the ready reasons
      this.sending = true;
      await api.addOffersFeedback({
        feedback: this.selected || 'other',
        feedback_details: this.other
      });
      this.sending = false;
      this.sent = true;
    }
  }
};
</script>

<style lang="scss">
.reason-other {
  border: 1px solid rgb(229, 231, 235) !important;
  font-size: 14px !important;
  height: 39px !important;
}

.reason-other:focus {
  background: rgba(236, 253, 245, var(--tw-bg-opacity)) !important;
  border-color: rgba(52, 211, 153, var(--tw-border-opacity)) !important;
  box-shadow: none !important;
}
</style>
